import Vue from 'vue'
import Router from 'vue-router'

import AttributesPage from '@/components/AttributesPage.vue'
import MyWheelzPage from '@/components/MyWheelzPage.vue'
import RoadMapPage from '@/components/RoadMapPage.vue'
import LimitedEditionsPage from '@/components/LimitedEditionsPage.vue'
import GeneratorPage from '@/components/GeneratorPage.vue'
import HomePage from '@/components/HomePage'
import TeamPage from '@/components/TeamPage'

Vue.use(Router)
export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/team',
    name: 'team',
    component: TeamPage
  },
  {
    path: '/mywheelz',
    name: 'MyWheelz',
    component: MyWheelzPage
  },
  {
    path: '/roadmap',
    name: 'RoadMap',
    component: RoadMapPage
  },
  {
    path: '/attribute_gallery',
    name: 'Attribute',
    component: AttributesPage
  },
  {
    path: '/limited_editions',
    name: 'LimitedEditions',
    component: LimitedEditionsPage
  },
  {
    path: '/generator',
    name: 'Generator',
    component: GeneratorPage
  }
  ]})

/*
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  export default router;
*/



// WEBPACK FOOTER //
// ./src/router/index.js